import React from "react";

export const Page404 = () => {
  return (
    <div className="flex-col w-screen h-screen flex items-center justify-center">
      <img src="/404.png" alt="404" />
    </div>
  );
};
